module.exports = __webpack_public_path__ + "static/media/store_mall_directory.c89765f7.svg";